var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeeworkLogoBlueYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675.82 184.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1cc81;}.cls-2{fill:#0f3951;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 571.09,
    y: 105.78,
    width: 9.01,
    height: 9.01,
    transform: "translate(204.75 -343.53) rotate(39.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-1",
    d: "M633.86,27.85,622.79,51.58,615,48l6.53-14a9.42,9.42,0,0,1-8.87.09c-5.8-2.71-10.46-10-6.3-19C610.22,6.86,618.51,4,626.64,7.77,634.46,11.42,637.87,19.26,633.86,27.85ZM614.4,18.46c-1.72,3.68-.52,7.33,3,9s7.09.22,8.81-3.46.52-7.33-3-9S616.12,14.78,614.4,18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-1",
    d: "M646.73,38.66l-21.44,15,4.91,7,12.64-8.85a9.43,9.43,0,0,0,1.46,8.76c3.66,5.24,11.7,8.55,19.76,2.91,7.44-5.21,8.85-13.87,3.7-21.22C662.81,35.21,654.51,33.22,646.73,38.66Zm12.63,17.53C656,58.52,652.23,58,650,54.79s-1.44-6.94,1.88-9.27,7.13-1.79,9.36,1.4S662.68,53.87,659.36,56.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-1",
    d: "M600.84,118.1l-16.05-13.47L592.06,96l16.05,13.47c3.81,3.2,6.69,2.47,8.87-.13s2.35-5.5-1.46-8.7l-16-13.47,7.27-8.66,16,13.47c3.81,3.2,6.69,2.46,8.82-.07s2.41-5.57-1.4-8.76L614.16,69.65,621.43,61l16.05,13.47c9.18,7.71,8.76,16.41,2.95,23.34-3.45,4.1-7.81,6.14-12.61,5.76,1.21,4.65-.09,9.37-3.48,13.41C618.52,123.89,610,125.81,600.84,118.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-1",
    d: "M600.21,43.18l16,13.47L609,65.31l-16-13.47c-3.81-3.2-6.69-2.47-8.87.13s-2.35,5.5,1.46,8.7l16.05,13.47-7.27,8.66-16-13.47c-3.81-3.2-6.69-2.46-8.82.07S567,75,570.84,78.16l16,13.47-7.27,8.67-16-13.47c-9.18-7.71-8.76-16.41-3-23.34,3.45-4.1,7.81-6.14,12.61-5.76-1.21-4.65.09-9.37,3.48-13.41C582.53,37.39,591,35.47,600.21,43.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    className: "cls-2",
    d: "M5,146.72V91.29H23.15V124c3.75-5.33,9.8-8.11,16.94-8.11,13.55,0,29,9.92,29,30.74,0,19.24-13.31,32.18-32.31,32.18C18.55,178.78,5,166.81,5,146.72Zm45.75.6c0-8.6-5.57-14.52-13.8-14.52s-13.8,5.92-13.8,14.52,5.56,14.52,13.8,14.52,13.8-5.93,13.8-14.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    className: "cls-2",
    d: "M81.21,147.32c0-18.15,13.31-31.46,32.19-31.46s31.83,13.31,31.83,31.46v5.09H100.09c1.45,7,6.77,10.16,13.31,10.16,5.2,0,9.08-1.09,11.38-4.36h18.76c-3.88,12.35-15.25,20.57-30.14,20.57C94.53,178.78,81.21,165.47,81.21,147.32Zm45.38-6.41c-2.06-6.17-6.9-8.84-13.19-8.84s-11.13,2.78-13,8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    className: "cls-2",
    d: "M158.31,147.32c0-18.15,13.31-31.46,32.19-31.46s31.83,13.31,31.83,31.46v5.09H177.19c1.45,7,6.77,10.16,13.31,10.16,5.2,0,9.07-1.09,11.37-4.36h18.76c-3.88,12.35-15.25,20.57-30.14,20.57C171.62,178.78,158.31,165.47,158.31,147.32Zm45.38-6.41c-2.06-6.17-6.9-8.84-13.19-8.84s-11.14,2.78-12.95,8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    className: "cls-2",
    d: "M237.18,151.07V117.43h18.16v33.64c0,8,3.87,10.77,9.31,10.77s9.2-2.78,9.2-10.77V117.43H292v33.64c0,8,3.88,10.77,9.2,10.77s9.32-2.78,9.32-10.77V117.43h18.15v33.64c0,19.24-11.13,27.71-25.65,27.71-8.59,0-15.61-3.26-20.09-9.55-4.48,6.29-11.62,9.55-20.09,9.55C248.32,178.78,237.18,170.31,237.18,151.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    className: "cls-2",
    d: "M341.44,147.32c0-18.15,13.32-31.46,32.2-31.46s32.19,13.31,32.19,31.46-13.32,31.46-32.19,31.46S341.44,165.47,341.44,147.32Zm46,0c0-8.59-5.56-14.52-13.8-14.52s-13.8,5.93-13.8,14.52,5.57,14.52,13.8,14.52,13.8-5.93,13.8-14.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    className: "cls-2",
    d: "M419.7,143.21c0-18.64,10.89-27.35,26.87-27.35s26.74,8.59,26.86,27.47v.36H455.28v-.48c0-8-3.63-10.41-8.71-10.41s-8.72,2.42-8.72,10.41v34H419.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    className: "cls-2",
    d: "M486.6,91.29h18.15V142.6l19-25.17h22.51l-24.32,29.29,25.29,30.5h-23l-19.49-25.78v25.78H486.6Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeworkLogoBlueYellow);
export default __webpack_public_path__ + "static/media/beework-logo-blue-yellow.51b75137af581c18b5412aa1736804c2.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;